import React from "react"
import ReactDOM from "react-dom"
import { StakingFlow } from "./lib"
import "./styles/fonts.css"

ReactDOM.render(
  <React.StrictMode>
    <StakingFlow />
  </React.StrictMode>,
  document.getElementById("root")
)
